import {
  Component,
  inject,
  input,
  InputSignal,
  OnDestroy,
  output,
  OutputEmitterRef,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../feedback/button/button.component';
import { IDialogResponse } from '../dialog';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { Router, Event, RouterEvent } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'aw-dialog',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './dialog.component.html',
})
export class DialogComponent<T> implements OnDestroy {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly subtitle: InputSignal<string | undefined> = input<string>();
  public readonly data: InputSignal<T> = input.required();
  public readonly icon: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly iconBackgroundColor: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly width: InputSignal<string> = input.required<string>();
  public readonly content: InputSignal<TemplateRef<unknown>> =
    input.required<TemplateRef<unknown>>();
  public readonly footer: InputSignal<TemplateRef<unknown> | undefined> =
    input<TemplateRef<unknown>>();
  public closingColor: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public fontSize: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public isValid: InputSignal<boolean> = input<boolean>(true);
  public isSaveDialog: InputSignal<boolean> = input<boolean>(false);

  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  private readonly router: Router = inject(Router);

  public readonly onClose: OutputEmitterRef<IDialogResponse<T>> =
    output<IDialogResponse<T>>();

  private readonly subscription: Subscription = new Subscription();

  constructor() {
    this.subscription.add(
      this.router.events.subscribe((event: Event) => {
        if ((event as RouterEvent).url === '/error') {
          this.cancel();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public cancel(): void {
    this.onClose.emit({
      submit: false,
      data: this.data(),
      acceptChanges: false,
    });
    this.onClose.emit({
      submit: false,
      data: this.data(),
      acceptChanges: false,
    });
  }

  public submit(): void {
    this.onClose.emit({
      submit: true,
      data: this.data(),
      acceptChanges: false,
    });
  }

  public save(): boolean {
    this.onClose.emit({ submit: true, data: this.data(), acceptChanges: true });
    return true;
  }
}
